import React from "react";
import clsx from "clsx";

import css from "./toggle.module.scss";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export function Toggle({ checked, onChange, disabled }: ToggleProps) {
  return (
    <span className={clsx(css.root, disabled && css.disabled)}>
      <input
        type="checkbox"
        checked={checked}
        onChange={e => onChange(e.target.checked)}
        className={css.input}
        disabled={disabled}
      />
      <span className={css.switch} />
    </span>
  );
}
